import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Home from "./pages/Home";
import reportWebVitals from "./reportWebVitals";
import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import Login from "./pages/Login";
import { Provider } from "react-redux";
import store from "./store/Store.js";
import LoginDetails from "./pages/pagecomponents/LoginDetails";
import Loginnew from "./pages/Loginnew.js";
import Dashboard from "./pages/Dashboard.js";
import Projectdisplay from "./pages/Dashboardcomponents/Projectdisplay.js";
// import Loginmain from "./pages/Loginmain.js";
import RedirectProject from "./pages/RedirectProject.js";
import DocumentationMD from "./pages/DocumenatationMD.js";
import Admin from "./pages/Admin.js";
const root = ReactDOM.createRoot(document.getElementById("root"));
// https://medium.com/@deepankaracharyya/deploying-a-django-app-with-apache-mod-wsgi-windows-e9712dc07bba
window.global = {
  // server_url: "https://" + window.location.hostname + ":8443",
  // server_url: "https://editlatex.transforma.in:8443/",
  // server_url: "http://10.10.10.46/editlatex_django/",
  // server_url: "http://10.10.10.57:8001/"
  server_url: window.location.protocol + "//" + window.location.hostname + ":8443/"
  // server_url: "http://192.168.1.17:8000/"
  // server_url: "http://localhost:8000/"
};
var base_path = "";
if (process.env.REACT_APP_STAGE === "webpage") {
  base_path = "";
}

root.render(
  <Provider store={store}>
    <ChakraProvider toastOptions={{ defaultOptions: { position: "top" } }}>
      {/* <React.StrictMode> */}
      <Router basename={base_path}>
        <Routes>
          <Route path="/home/" element={<Home />} />
          <Route path="/home/:page" element={<Home />} />
          <Route path="/:projectid" element={<RedirectProject />} />
          <Route path="/:projectid/:file" element={<App />} />
          {/* <Route path="/login/" element={<Login />} /> */}
          <Route path="/tryit" element={<LoginDetails />} />
          <Route path="/docs" element={<DocumentationMD />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/loginnew/:loginpages" element={<Loginnew />}>
            <Route path=":action" element={<Loginnew />} />
          </Route>
          <Route path="/dashboard" element={<Dashboard />}>
            <Route path=":project" element={<Projectdisplay />} />
          </Route>
        </Routes>
      </Router>
      {/* </React.StrictMode> */}
    </ChakraProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
